import type { backendCriticity } from "../../backend/target/typescript/dto";

export type Criticity = backendCriticity;

export function criticityEqualOrAbove(
  value: Criticity,
  threshold: Criticity
): boolean {
  const order: Criticity[] = ["OK", "WARNING", "CRITICAL"];
  return order.indexOf(value) >= order.indexOf(threshold);
}

export function criticityPill(
  value: Criticity | undefined,
  text?: string
): React.ReactNode {
  // https://getbootstrap.com/docs/5.0/components/badge/
  return (
    <span className={`badge rounded-pill text-bg-${criticityToCSS(value)}`}>
      {text ?? criticityToText(value)}
    </span>
  );
}

export function criticityToCSS(value: Criticity | undefined): string {
  switch (value) {
    case "CRITICAL":
      return "danger";
    case "WARNING":
      return "warning";
    case "OK":
      return "success";
    default:
      return "secondary";
  }
}

export function criticityToText(value: Criticity | undefined): string {
  switch (value) {
    case "CRITICAL":
      return "Critical";
    case "WARNING":
      return "Warning";
    case "OK":
      return "Ok";
    case undefined:
      return "None";
    default:
      return "Unknown";
  }
}
